import React, {useEffect} from "react";
import {Grid} from "@mui/material";
import Typography from "@mui/material/Typography";

export const Logout = () => {
    useEffect(() => {
        console.log('logging out')
        localStorage.removeItem('user');
        localStorage.removeItem('fno_selected_users_sell');
        localStorage.removeItem('fno_selected_users_buy');
        window.location.href = '/algo-trading/index.html';
    }, []);
    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h6" component="h6">
                    Logging out...
                </Typography>
            </Grid>
        </>
    );
}